<template>
    <div class="col-lg-12 col-xl-12">
        <div class="card card-custom gutter-b bg-white border-0">
            <div class="card-body">
                <div class="col-12" style="padding: 0">
                    <button v-if="editable" class="btn btn-sm btn-primary white float-right" @click="addProduct()">+</button>
                    <div class="table-responsive">
                        <table class="table table-striped text-body" id="orderTable">
                            <thead>
                                <tr>
                                    <th class="border-0 header-heading" scope="col">ID</th>
                                    <th class="border-0 header-heading" scope="col">Название</th>
                                    <th class="border-0 header-heading" scope="col">Цена</th>
                                    <th class="border-0 header-heading" scope="col">Кол-во</th>
                                    <th v-if="editable" class="border-0 header-heading" scope="col">Действие</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="" v-for="(selectedProduct, index) in selectedProducts" :key="index">
                                    <td class="text-center">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="text-center">
                                        <div class="input-group">
                                            <input type="text" class="form-control" :readonly="!editable" placeholder="Ввести название"
                                                :value="selectedProduct.name"
                                                @change="updateProductName(selectedProduct, $event)" />
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="input-group">
                                            <input type="number" step="0.01" class="form-control" :readonly="!editable" placeholder="Ввести цену"
                                                :value="selectedProduct.price"
                                                @change="updateProductPrice(selectedProduct, $event)" />
                                            <div class="input-group-append">
                                                <span class="input-group-text" style="border: none;">{{ currencySymbol }}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <div class="input-group">
                                            <input type="number" :readonly="!editable" class="form-control" placeholder="Ввести количество" :value="selectedProduct.qty"
                                                @change="updateProductQty(selectedProduct, $event)" />
                                        </div>
                                    </td>
                                    <td v-if="editable" class="text-center">
                                        <bntton @click="removeProduct(index)"><i class="fa fa-trash"></i></bntton>
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Offer",
    props: {
  	    editable: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        currencySymbol() {
            return window.appConfig?.currencySymbol || '€';
        },
        selectedProducts() {
            return this.$store.getters['offer/selectedProducts'];
        }
    },
    methods: {
        addProduct() {
            this.$store.dispatch('offer/addProduct', {
                name: '',
                qty: 0,
                price: 0,
            });
        },
        updateProductName(selectedProduct, event) {
            this.$store.commit('offer/updateProductName', { selectedProduct, name: event.target.value });
        },
        updateProductPrice(selectedProduct, event) {
            this.$store.commit('offer/updateProductPrice', { selectedProduct, price: event.target.value });
        },
        updateProductQty(selectedProduct, event) {
            this.$store.commit('offer/updateProductQty', { selectedProduct, qty: event.target.value });
        },
        removeProduct(productToRemove){
            console.log('remove')
            this.$store.dispatch('offer/removeProduct', productToRemove);
        }
    },
    mounted() {
        //this.addProduct();
    }
};
</script>


